import { Toaster as Sonner } from "sonner";
import type { ToasterProps } from "sonner";
import { useResolvedMode } from "~/hooks/resolved-mode-hook";

const Toaster = ({ ...props }: ToasterProps) => {
  const mode = useResolvedMode();

  return (
    <Sonner
      theme={mode}
      className="toaster group"
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)",
        } as React.CSSProperties
      }
      {...props}
    />
  );
};

export { Toaster };
